import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";

import { FormInstance } from "antd/es/form/hooks/useForm";
import { useIntl } from "react-intl";

import { setCustomFieldEditStep } from "@app/scene/settings/component/CustomFields/store/actions";
import DefaultCustomFieldFormValues from "@app/scene/settings/component/CustomFields/type/DefaultCustomFieldFormValues";
import CreateEditCustomFieldStep from "@app/scene/settings/enum/CreateEditCustomFieldStep";
import { isCustomFieldCreating, isCustomFieldUpdating } from "@app/store/customFields";
import { RootState } from "@app/store/rootReducer";
import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

import FieldAccess from "../FieldAccess";
import styles from "../FieldSetup/FieldSetup.module.scss";
import StepControl from "../StepControl";

interface Props {
  analyticIssuer?: AnalyticsService;
  form: FormInstance<DefaultCustomFieldFormValues>;
  loading: boolean;
  setStep: typeof setCustomFieldEditStep;
}

const ShareSave: React.FC<Props> = ({ analyticIssuer, form, loading, setStep }) => {
  const intl = useIntl();

  useEffect(() => {
    analyticIssuer?.clicked(["Share & Save"]);
  }, [analyticIssuer]);

  const handleBackStepClick = useCallback(
    () => setStep(CreateEditCustomFieldStep.FIELD_SETUP),
    [setStep]
  );

  const handleNextStepClick = useCallback(async () => {
    analyticIssuer?.clicked(["Share & Save", "Save"]);
    form.submit();
  }, [analyticIssuer, form]);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <FieldAccess customField />
      </div>
      <StepControl
        nextButtonProps={{ loading }}
        nextButtonText={intl.formatMessage({
          id: "settings.customFields.createEditPane.shareSave.saveCustomField",
          defaultMessage: "Save Custom Field",
          description: "Settings Custom field - create/edit - share&save - Save Custom Field",
        })}
        onBack={handleBackStepClick}
        onNext={handleNextStepClick}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  loading: isCustomFieldCreating(state) || isCustomFieldUpdating(state),
});

const mapDispatchToProps = {
  setStep: setCustomFieldEditStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareSave);
